import {Grid, Typography} from '@material-ui/core';
import React from 'react';
import Pic from '../assets/images/500.png';
import {makeStyles} from '@material-ui/core/styles';
import Server from '../assets/images/server-down.png';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pic: {
    width: '65%',
    height: 'auto',
    alignItems: 'center',
    margin: '0 auto',
    justifyContent: 'center',
    '@media (max-width : 700px)': {
      width: '90%',
    },
  },
  eng: {
    color: '#555',
    opacity: '50%',
    fontSize: '25px',
    fontFamily: 'iranSans',
    fontWeight: 'bold',
    marginTop: '12px',
  },
  per: {
    color: '#2383c0',
    fontSize: '30px',
    fontFamily: 'iranSans',
    padding: '10px',
    fontWeight: 'bold',
    textShadow: '1px 2px 4px #aaa',
    '@media (max-width : 700px)': {
      fontSize: '20px',
    },
  },
  goHomeButton: {
    marginTop: theme.spacing(1),
    border: '1px solid #2383c0',
    borderRadius: '50px',
    boxShadow: '2px 2px 4px #aaa',
    '&:hover': {boxShadow: 'none'},
  },
  icon: {
    width: '20%',
  },
}));

export default function ServerDown() {
  const classes = useStyles();
  return (
    <Grid className={classes.root}>
      <Grid direction="column" container alignItems={'center'}>
        <Grid
          item
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={Pic} alt={'404pic'} className={classes.pic} />
        </Grid>
        <Grid item className={classes.eng}>
          Internal Server Error...
        </Grid>
        <Grid item>
          <Typography className={classes.per} noWrap>
            اکنون دسترسی به سرور امکان پذیر نیست...
          </Typography>
        </Grid>
        <Grid item>
          <Grid
            item
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img src={Server} alt={'404pic'} className={classes.icon} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
